import React from 'react'
import { formatMoney } from '@ztechapps/common.utils'
import { UomDisplay } from './QuantityWithUom'

export type PricePerUomProps = {
  price: number
  /** UOM label to display after "per" — can be symbol (e.g. "ea", "ft") or name (e.g. "Each", "Foot") */
  uom: string
  className?: string
}

export const PricePerUom = ({ price, uom, className = 'small text-muted' }: PricePerUomProps) => (
  <div className={className}>
    {formatMoney(price)} per <UomDisplay>{uom}</UomDisplay>
  </div>
)
